const AdminUserDeleteRemoveStyle = {
  bg: "white",
  flexWrap: "wrap",
  width: "100%",
};

export { AdminUserDeleteRemoveStyle };
